import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Form } from 'react-bootstrap';
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css';

const FacturasConciliarFiltros = ({
    rfcSeleccionado,
    fechaInicialFacturas,
    setFechaInicialFacturas,
    fechaFinalFacturas,
    setFechaFinalFacturas,
    tipoDocumento,
    setTipoDocumento,
    serieFactura,
    setSerieFactura,
    montoMinimo,
    setMontoMinimo,
    montoMaximo,
    setMontoMaximo
}) => {
    return (
        <div className="p-3 bg-light border-bottom">
            <Row className="g-2">
                <Col md={4}>
                    <Form.Group>
                        <Form.Label className="text-700 fw-semi-bold fs--2 mb-1">Fecha Inicial</Form.Label>
                        <DatePicker
                            selected={fechaInicialFacturas}
                            onChange={(date) => setFechaInicialFacturas(date)}
                            dateFormat="dd/MM/yyyy"
                            className="form-control form-control-sm"
                            placeholderText="Seleccione fecha"
                            disabled={!rfcSeleccionado}
                        />
                    </Form.Group>
                </Col>
                <Col md={4}>
                    <Form.Group>
                        <Form.Label className="text-700 fw-semi-bold fs--2 mb-1">Fecha Final</Form.Label>
                        <DatePicker
                            selected={fechaFinalFacturas}
                            onChange={(date) => setFechaFinalFacturas(date)}
                            dateFormat="dd/MM/yyyy"
                            className="form-control form-control-sm"
                            placeholderText="Seleccione fecha"
                            disabled={!rfcSeleccionado}
                        />
                    </Form.Group>
                </Col>
                <Col md={4}>
                    <Form.Group>
                        <Form.Label className="text-700 fw-semi-bold fs--2 mb-1">Tipo de Documento</Form.Label>
                        <Form.Select
                            size="sm"
                            value={tipoDocumento}
                            onChange={(e) => setTipoDocumento(e.target.value)}
                            disabled={!rfcSeleccionado}
                        >
                            <option value="">Todos</option>
                            <option value="I">I - Ingreso</option>
                            <option value="E">E - Egreso</option>
                            <option value="P">P - Pago</option>
                            <option value="N">N - Nómina</option>
                        </Form.Select>
                    </Form.Group>
                </Col>
            </Row>

            <Row className="g-2 mt-1 pt-2 border-top">
                <Col md={4}>
                    <Form.Group>
                        <Form.Label className="text-700 fw-semi-bold fs--2 mb-1">Serie</Form.Label>
                        <Form.Control
                            type="text"
                            size="sm"
                            placeholder="Ej. A, F..."
                            value={serieFactura}
                            onChange={(e) => setSerieFactura(e.target.value)}
                            disabled={!rfcSeleccionado}
                        />
                    </Form.Group>
                </Col>
                <Col md={4}>
                    <Form.Group>
                        <Form.Label className="text-700 fw-semi-bold fs--2 mb-1">Monto Mínimo</Form.Label>
                        <Form.Control
                            type="number"
                            size="sm"
                            placeholder="0.00"
                            step="0.01"
                            value={montoMinimo}
                            onChange={(e) => setMontoMinimo(e.target.value)}
                            disabled={!rfcSeleccionado}
                        />
                    </Form.Group>
                </Col>
                <Col md={4}>
                    <Form.Group>
                        <Form.Label className="text-700 fw-semi-bold fs--2 mb-1">Monto Máximo</Form.Label>
                        <Form.Control
                            type="number"
                            size="sm"
                            placeholder="0.00"
                            step="0.01"
                            value={montoMaximo}
                            onChange={(e) => setMontoMaximo(e.target.value)}
                            disabled={!rfcSeleccionado}
                        />
                    </Form.Group>
                </Col>
            </Row>
        </div>
    );
};



FacturasConciliarFiltros.propTypes = {
    rfcSeleccionado: PropTypes.string,
    fechaInicialFacturas: PropTypes.instanceOf(Date),
    setFechaInicialFacturas: PropTypes.func,
    fechaFinalFacturas: PropTypes.instanceOf(Date),
    setFechaFinalFacturas: PropTypes.func,
    tipoDocumento: PropTypes.string,
    setTipoDocumento: PropTypes.func,
    montoMinimo: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    setMontoMinimo: PropTypes.func,
    montoMaximo: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    setMontoMaximo: PropTypes.func
};

export default FacturasConciliarFiltros;
